import React, {memo} from "react"
import {Handle, Position} from "@xyflow/react"
import Tooltip from "./Tooltip"

export default memo(({data}) => {
    const size = data.size
    const width = size?.width || 200
    const height = size?.height || 60

    return (
        <Tooltip id={data.id}>
            <div
                className="flexRow center"
                style={{
                    position: "relative", // for the handle to be positioned correctly
                    width,
                    height,
                    border: "1px solid #333",
                    fontSize: "16px",
                    backgroundColor: data.color
                }}
            >
			<span style={{marginLeft: 10}}>
				{data.label}
			</span>
                {data.level >= 1 && <Handle type="target" position={Position.Left} id="left"/>}
                <Handle type="source" position={Position.Right} id="right"/>
            </div>
        </Tooltip>
    )
})
